export default __webpack_public_path__ + "assets/images/2db164a7446d944164d835404f074144.svg";